import React, { useEffect } from 'react';
import Sidebar from '../Components/Sidebar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function Layout() {
  const { authUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { showToast } = useToast();

  useEffect(() => {
    if (location.state?.toastMessage) {
      showToast(location.state.toastMessage, location.state.toastType || 'success');
      // Bersihkan location.state lewat navigate({replace:true}) milik React
      // Router, BUKAN window.history.replaceState() mentah. Memanggil History
      // API browser langsung membuat state internal React Router (location.key,
      // dst) tidak sinkron dengan history entry browser yang sesungguhnya --
      // efeknya baru terlihat di navigasi BERIKUTNYA (mis. rute yang sama
      // dikunjungi dua kali berturut-turut, seperti /employee/:id/access
      // setelah save lalu dibuka lagi).
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div className="container-fluid p-0 bg-light">
      <div
        className="d-flex overflow-hidden"
        style={{ minHeight: '100vh', width: '100vw' }}
      >
        <Sidebar />
        <div className="flex-grow-1 d-flex flex-column">
          <header className="border-bottom p-3 d-flex justify-content-between align-items-center">
            <h5>Dashboard</h5>
            <span className="d-flex align-items-center gap-2">
              <div className="bg-light rounded-circle p-2 d-flex justify-content-center align-items-center">
                <i className="bi bi-person text-primary"></i>
              </div>
              <span className="fw-semibold">{authUser?.fullName}</span>
            </span>
          </header>

          <main
            className="flex-grow-1 overflow-auto p-4 bg-light"
            style={{
              height: 0, // penting untuk membuat scroll hanya di main
            }}
          >
            <Outlet />
          </main>

          <footer className="text-center py-2 small text-muted border-top">
            © 2025 Bakrie Center Foundation — ILS-SA
          </footer>
        </div>
      </div>
    </div>
  );
}
